import { ReactNode } from "react";

interface SectionProps {
  children: ReactNode;
  title: ReactNode;
  "data-component"?: never;
}

export const Section = ({ children, title, ...props }: SectionProps) => {
  return (
    <div className="py-sm" data-component="Section" {...props}>
      <h2 className="mb-xs text-lg font-semibold text-brand" data-component="SectionHeader">
        {title}
      </h2>
      <div className="grid gap-sm">{children}</div>
    </div>
  );
};

interface SectionItemProps {
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
}

const SectionItem = ({ children, icon, title }: SectionItemProps) => (
  <div className="flex gap-xs" data-component="SectionItem">
    {icon && (
      <div className="flex h-[50px] w-[50px] justify-center rounded-full border">{icon}</div>
    )}
    <div className="flex flex-col self-center text-sm">
      {title && <span className="font-medium">{title}</span>}
      {children && <span>{children}</span>}
    </div>
  </div>
);

Section.Item = SectionItem;
